import { useExplorationData } from '../context/ExplorationContext';
import { computeLoadingPercent } from '../lib/loading/loadingStages';
import Typography from '~/shared/components/Typography';

export default function ExplorationLoadingOverlay() {
  const { loading, loadingProgress } = useExplorationData();
  if (!loading) return null;

  const total = loadingProgress?.total ?? 0;
  const pct = computeLoadingPercent(loadingProgress?.loaded ?? 0, total);
  const loadedCount = (loadingProgress?.loaded ?? 0).toLocaleString();
  const totalCount = total.toLocaleString();

  return (
    <div
      className="exploration-canvas-dots absolute inset-0 z-[15] flex items-center justify-center"
      aria-busy="true"
      role="status"
    >
      <div className="flex flex-col items-center gap-2.5 px-5 py-[20px] max-w-[495px] w-full">
        <Typography
          variant="H3"
          fontWeight={400}
          color="text-primary-900"
          className="font-family-outfit text-center w-full"
        >
          Loading
          <span aria-hidden="true" className="exploration-loading-dots">
            <span className="exploration-loading-dot" />
            <span className="exploration-loading-dot" />
            <span className="exploration-loading-dot" />
          </span>
        </Typography>
        <Typography
          variant="p2-semi"
          fontWeight={500}
          color="text-gray-700"
          className="text-center w-full !leading-5"
        >
          {pct}% completed
        </Typography>
        <div className="h-6 w-full flex items-center">
          <div
            className="h-2 w-full bg-primary-70 rounded overflow-hidden"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={pct}
            aria-label="Loading progress"
          >
            <div
              className="h-full bg-primary-500 rounded transition-[width] duration-200 motion-reduce:transition-none"
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>
        {total > 0 && (
          <Typography
            variant="p3-reg"
            color="text-gray-700"
            className="text-center w-full"
            aria-live="polite"
          >
            {loadedCount}/{totalCount} volumes
          </Typography>
        )}
      </div>
    </div>
  );
}
